import { render } from "./DonutChart.vue?vue&type=template&id=5fd4f33e"
import script from "./DonutChart.vue?vue&type=script&lang=js"
export * from "./DonutChart.vue?vue&type=script&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=5fd4f33e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__